const navigateToPage = (path) => {
  window.location.href = path;
};
export default navigateToPage;
